import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import styled from 'styled-components';
import { InputStyled } from '@components/dashboard/SharedStyles';
import FormFieldError from '@components/shared/Form/FormFieldError';
import { InputDescription, P } from '@components/shared/Typography';
import useReplacedInnerHtml from '@utils/useReplacedInnerHtml';
import Colors from '../Colors';
import HeightInput from './HeightInput';
import WeightInput from './WeightInput';

export default function Input(props) {
  const { id, label, description, style, referenceId, className, ...rest } = props;
  const [field, meta] = useField(props);
  const hasError = meta.error && meta.touched;
  const [initialValue, setInitialValue] = useState<string | number | null>();
  const labelRef = useReplacedInnerHtml(label);
  const descriptionRef = useReplacedInnerHtml(description);

  useEffect(() => {
    setInitialValue(field.value);
  }, []);

  const renderInput = () => {
    if (referenceId === 'weight') {
      return (
        <>
          <WeightInput id={id} initialValue={initialValue} />
          <InputStyled {...field} {...rest} hidden={true} />
        </>
      );
    }
    if (referenceId === 'height') {
      return (
        <>
          <HeightInput id={id} initialValue={initialValue} />
          <InputStyled {...field} {...rest} hidden={true} />
        </>
      );
    }
    return <InputStyled $error={hasError} {...field} {...rest} />;
  };

  return (
    <InputWrapper style={style} className={className}>
      {label && <PStyled $error={hasError} ref={labelRef} />}
      {description && <InputDescription ref={descriptionRef} />}
      {renderInput()}
      {hasError && <FormFieldError message={meta.error || ''} style={{ marginTop: 10 }} />}
    </InputWrapper>
  );
}

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }

  &.half {
    flex-basis: 50%;
    padding: 0 10px 0 0;
  }

  &.half + .half {
    padding: 0 0 0 10px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const PStyled = styled(P)<{ $error: any }>`
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  margin-top: 0;
  color: ${(props) => (props.$error ? Colors.red : 'inherit')};

  &:first-child {
    margin-top: 0;
  }
`;
